import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

const DesktopHeaderContainer = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$enableCentreTitle: boolean; $sticky: boolean}>`
    width: 100%;
    overflow: visible;
    background: white;
    padding: 0;
    align-items: center;
    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0 0rem 1rem 0rem;
        grid-template-columns: 1fr auto 1fr;
        display: grid;
        grid-template-areas: "empty title end";
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0.25rem 1rem 1rem 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    @media (max-width: ${breakpoints.values.md - 1}px) {
        display: grid;
        grid-template-areas: "title empty end";
        grid-template-columns: 20fr 0fr 1fr;
        padding: 0.25rem 1rem 1rem 0rem;
    }
`
DesktopHeaderContainer.displayName = "Cashmere25DesktopHeaderContainer"

export default DesktopHeaderContainer
